import { defaultTo, map, orderBy } from 'lodash';
import { IModel, Model, ModelRecord, QuestionModel } from '@common/models';

export interface ISectionModel extends IModel {
  sectionId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  questions: QuestionModel[];
}

export class SectionModel extends Model implements ModelRecord<ISectionModel> {
  sectionId: number;
  name: string;
  displayName: string;
  sortOrder: number;
  questions: QuestionModel[] = [];

  constructor(params?: Partial<ISectionModel>) {
    super(params);
    this.sectionId = defaultTo(params?.sectionId, 0);
    this.name = defaultTo(params?.name, '');
    this.displayName = defaultTo(params?.displayName, '');
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    map(
      orderBy(params?.questions, (v) => v.sortOrder),
      (question) => {
        this.questions.push(new QuestionModel(question));
      },
    );
  }
}
